<app-modal-v2>
  <div class="modal-m guest-set-password__modal">
    <app-modal-content>
      <div class="modal-body">
        <div class="guest-register-modal__header">
          <div class="d-flex justify-content-between">
            <app-logo [preventClick]="true"></app-logo>
          </div>
          <h2 class="mt16 uppercase-m semibold modal-header__title">
            {{ 'guest_mode.register_modal.title_l' | translate }}
          </h2>
          <h3 class="title-xl modal-header__subtitle">
            {{ 'guest_mode.register_modal.sub_title_l' | translate }}
          </h3>
        </div>

        @if (declareIntent()) {
          <p
            class="ml16 mr16"
            [innerHTML]="'guest_mode.register_modal.intent_l' | translate"
          ></p>
        }
        @if (isApplying()) {
          <p
            class="ml16 mr16"
            [innerHTML]="
              (itpCustomerName()
                ? 'guest_mode.application.register_advantages_itp_l'
                : 'guest_mode.application.register_advantages_no_itp_l'
              ) | translate: { customerName: itpCustomerName() }
            "
          ></p>
        }

        <form
          [formGroup]="form"
          class="guest-set-password__form"
          autocomplete="off"
        >
          <div class="col-12 mb20">
            <label class="im:floating-label">
              <span floatingLabel>{{ 'general.email_l' | translate }}</span>
              <input
                class="im:input"
                type="text"
                [readonly]="true"
                formControlName="email"
              />
            </label>
          </div>

          <div class="col-12 mb20">
            <app-password
              [label]="'forms.type_password'"
              [showRequiredBox]="true"
              [placeholder]="'forms.password_placeholder' | translate"
              formControlName="password"
            >
            </app-password>
          </div>

          <div class="col-12 terms-of-use">
            <div class="im:card guest-register-modal__terms-info">
              <i class="icon icon--info" aria-hidden="true"></i>
              <p class="im:body">
                {{ 'register.terms_info_intro_l' | translate }}
                <a
                  im-button
                  [href]="termsUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  >{{
                    'immomio_now.subscription.register_terms_link_a' | translate
                  }}</a
                >
                {{ 'register.terms_info_privacy_l' | translate }}
                <a
                  im-button
                  [href]="externalDataPrivacyLink"
                  target="_blank"
                  rel="noopener noreferrer"
                  >{{
                    'immomio_now.subscription.register_privacy_link_a'
                      | translate
                  }}</a
                >.
              </p>
            </div>
          </div>

          @if (captchaActive()) {
            <div class="col-12 guest-register-modal__captcha">
              <app-friendly-captcha
                formControlName="captcha"
                [sitekey]="captchaSiteKey()"
              ></app-friendly-captcha>
            </div>
          }
        </form>
      </div>
    </app-modal-content>

    <app-modal-footer>
      <div class="modal-footer guest-set-password__footer">
        <button im-button class="inverted" (click)="dismiss()">
          {{ 'general.cancel_a' | translate }}
        </button>
        @if (isApplying()) {
          <button im-button class="inverted" (click)="continueAsGuest()">
            {{ 'guest_mode.register_modal.continue_as_guest_a' | translate }}
          </button>
        }
        <button
          im-button
          class="primary"
          [disabled]="form.invalid"
          (click)="register()"
        >
          {{ 'guest_mode.application.register_now_l' | translate }}
        </button>
      </div>
    </app-modal-footer>
  </div>
</app-modal-v2>
